/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable react/no-unknown-property */
import { IComponentProps } from '@msdyn365-commerce/core';
import React from 'react';
import {
    BsFillFileEarmarkBarGraphFill,
    BsFileEarmarkRichtextFill,
    BsFileEarmarkPostFill,
    BsFileEarmarkFontFill,
    BsFileEarmarkCodeFill,
    BsFileEarmarkEaselFill
} from 'react-icons/bs';
import {
    FaFile,
    FaFileArchive,
    FaFileAudio,
    FaFileCode,
    FaFileCsv,
    FaFileExcel,
    FaFileImage,
    FaFileInvoice,
    FaFilePdf,
    FaFilePowerpoint,
    FaFileSignature,
    FaFileVideo,
    FaFileWord,
    FaGoogleDrive,
    FaHtml5,
    FaLeanpub
} from 'react-icons/fa';
import { HiDocumentReport } from 'react-icons/hi';
import { RiFileGifFill } from 'react-icons/ri';
import { SiMicrosoftoutlook } from 'react-icons/si';
import { IMoeSearchResultContainerResources } from '../moe-search-result-container.props.autogenerated';
export interface ICollectionItemComponentProps extends IComponentProps<{}> {
    className?: string;
    artifacts: any;
    showMoreArtifacts: any;
    ArtifactsDataAttributes: any;
    resources?: IMoeSearchResultContainerResources;
    preferredLanguageForError: string;
}

export const ArtifactsListView: React.FC<ICollectionItemComponentProps> = (props: any) => {
    const { artifacts, className, resources, preferredLanguageForError } = props;
    console.log('external resources', artifacts);

    // variable declaration
    const IMSCCRemovedArtifacts = artifacts.filter(
        (artifact: any) =>
            artifact?.FILETYPE?.toUpperCase() !== 'IMSCC' && !(artifact?.MEDIANAME as string).includes('CogSearchIndexHelper')
    );

    return (
        <>
            {IMSCCRemovedArtifacts && IMSCCRemovedArtifacts.length > 0 ? (
                <div className={className}>
                    {IMSCCRemovedArtifacts?.map((artifact: any, index: number) => (
                        <ArtifactResource id={artifact.Id} artifact={artifact} key={artifact.Id} />
                    ))}
                    {/* <div className='moe-search-artifacts-resources-showmore--btn'> */}
                    {/* <button onClick={showMoreExternalResources} className='moe-btn moe-btn--primary-blue'> */}
                    {/* Show More */}
                    {/* <span className='moe-search-ext-resources-showmore--spinner'></span> */}
                    {/* </button> */}
                    {/* </div> */}
                </div>
            ) : (
                <div className='msc-alert msc-alert-warning'>
                    {preferredLanguageForError === 'maori' ? resources.resultSearchNotFoundTextInMaori : resources.resultSearchNotFoundText}
                    .
                </div>
            )}
        </>
    );
};

const ArtifactResource = (props: any) => {
    const { artifact } = props;

    return (
        <div className='moe-search-artifacts-resource'>
            <div className='moe-search-ext-resource__header'>
                {/* <a
                    target='_blank'
                    download={artifact?.MEDIANAME}
                    rel='noreferrer'
                    className='tooltip-test'
                    title='Word File'
                    href={artifact.MEDIAURL}
                    aria-label={`Read More about ${artifact.MEDIAURL}`}
                > */}
                {renderDocument(artifact)}
                {/* </a> */}
                <p>{artifact?.MEDIANAME || 'Resource name is not available for this.'}</p>
            </div>
            <div className='moe-search-ext-resource__footer'>
                <p>
                    <b>Resource: </b>
                    {artifact?.ProductName || 'Resource name is not available for this.'}
                </p>
                <p>
                    <b>Format: </b>.{artifact?.FILETYPE?.toLowerCase() || 'ext'}
                </p>
                <p>
                    <b>Intended end user role: </b>
                    {artifact?.INTENDEDUSERROLE || 'none'}
                </p>
            </div>
        </div>
    );
};

// const getArtifactIcon = (FILETYPE: any): any => {
//     const fileType = FILETYPE?.toUpperCase();
//     switch (fileType) {
//         case 'DOC':
//             return <FaFileWord />;
//         case 'IMAGE':
//             return <FaFileImage />;
//         case 'EXCEL':
//             return <FaFileExcel />;
//         case 'PPT':
//             return <FaFilePowerpoint />;
//         case 'EPUB':
//             return <FaLeanpub />;
//         case 'PDF':
//             return <FaFilePdf />;
//         case 'GOOGLEDOC':
//             return <FaGoogleDrive />;
//         case 'IMSCC':
//             break;
//         default:
//             return <FaFile />;
//     }
// };

function renderWordFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileWord></FaFileWord>
        </a>
    );
}

function renderExcelFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileExcel></FaFileExcel>
        </a>
    );
}

function renderPPTFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFilePowerpoint></FaFilePowerpoint>
        </a>
    );
}

function renderPDFFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFilePdf></FaFilePdf>
        </a>
    );
}

function renderImageFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileImage />
        </a>
    );
}

function renderGoogleDocFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaGoogleDrive />
        </a>
    );
}

function renderAviFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileVideo />
        </a>
    );
}

function renderBmpFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileImage />
        </a>
    );
}

function renderCsvFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileCsv />
        </a>
    );
}

function renderDocFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileWord />
        </a>
    );
}

function renderGifFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <RiFileGifFill />
        </a>
    );
}

function renderHTMLFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaHtml5 />
        </a>
    );
}

function renderJSONFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileInvoice />
        </a>
    );
}

function renderMhpFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <BsFillFileEarmarkBarGraphFill />
        </a>
    );
}

function renderCodeFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileCode />
        </a>
    );
}

function renderMsgFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <SiMicrosoftoutlook />
        </a>
    );
}

function renderRTFFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <BsFileEarmarkRichtextFill />
        </a>
    );
}

function renderSGMLFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <BsFileEarmarkPostFill />
        </a>
    );
}

function renderTxtFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <BsFileEarmarkFontFill />
        </a>
    );
}

function renderVsdFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileSignature />
        </a>
    );
}

function renderXmlFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <BsFileEarmarkCodeFill />
        </a>
    );
}

function renderZipFile(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFileArchive />
        </a>
    );
}

function renderotherFiles(fileURL: any, MediaName: string) {
    return (
        <a
            download={MediaName}
            target='_blank'
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFile />
        </a>
    );
}

function renderGSlides(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaFilePowerpoint></FaFilePowerpoint>
        </a>
    );
}

function renderEbookPreview(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download={MediaName}
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${MediaName}`}
        >
            <FaLeanpub></FaLeanpub>
        </a>
    );
}

function renderAudioFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <FaFileAudio size={30}></FaFileAudio>
        </a>
    );
}

function renderVideoFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <FaFileVideo size={30}></FaFileVideo>
        </a>
    );
}

function renderPbixFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <HiDocumentReport size={30}></HiDocumentReport>
        </a>
    );
}

function renderUsdzFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>
        </a>
    );
}

function renderDaeFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <BsFileEarmarkEaselFill size={30}></BsFileEarmarkEaselFill>
        </a>
    );
}

function renderXsnFile(fileURL: any, MediaName: string) {
    return (
        <a
            target='_blank'
            download
            rel='noreferrer'
            className='tooltip-test'
            title={MediaName}
            href={fileURL}
            aria-label={`Read More about ${fileURL}`}
        >
            <FaFileCode size={30}></FaFileCode>
        </a>
    );
}

function renderDocument(item: any) {
    if (item?.FILETYPE?.toUpperCase() === 'DOC') {
        return renderWordFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'IMAGE') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'EXCEL') {
        return renderExcelFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'PPT') {
        return renderPPTFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'PDF') {
        return renderPDFFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'GOOGLEDOC') {
        return renderGoogleDocFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'AVI') {
        return renderAviFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'BMP') {
        return renderBmpFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'CSV') {
        return renderCsvFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'DOC') {
        return renderDocFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'DOCX') {
        return renderDocFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'GIF') {
        return renderGifFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'HTM') {
        return renderHTMLFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'HTML') {
        return renderHTMLFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'JPEG') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'JPG') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'JSON') {
        return renderJSONFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'MHP') {
        return renderMhpFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'MHTML') {
        return renderCodeFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'MSG') {
        return renderMsgFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'PNG') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'PPT') {
        return renderPPTFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'PPTX') {
        return renderPPTFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'RTF') {
        return renderRTFFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'SGML') {
        return renderSGMLFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'TIF') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'TXT') {
        return renderTxtFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'VSD') {
        return renderVsdFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'WMF') {
        return renderImageFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'XHTML') {
        return renderCodeFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'XLS') {
        return renderExcelFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'XLSX') {
        return renderExcelFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'XML') {
        return renderXmlFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'ZIP') {
        return renderZipFile(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'GSLIDES') {
        return renderGSlides(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FILETYPE?.toUpperCase() === 'EPUB') {
        return renderEbookPreview(item.MEDIAURL, item.MEDIANAME);
    } else if (item?.FileType?.toUpperCase() === 'WAV') {
        return renderAudioFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'MP3') {
        return renderAudioFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'WMA') {
        return renderAudioFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'MP4') {
        return renderVideoFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'MPEG') {
        return renderVideoFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'MOV') {
        return renderVideoFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'PIBX') {
        return renderPbixFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'USDZ') {
        return renderUsdzFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'DAE') {
        return renderDaeFile(item.MediaUrl, item.MediaName);
    } else if (item?.FileType?.toUpperCase() === 'XSN') {
        return renderXsnFile(item.MediaUrl, item.MediaName);
    } else {
        return renderotherFiles(item.MEDIAURL, item.MEDIANAME);
    }
}
